
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/new",
      function () {
        return require("private-next-pages/[slug]/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/new"])
      });
    }
  